import { dockPadEntityMapToList } from "../containers/DockPadFormTemplates"
import { createSelector } from "reselect"
import { getProject } from "./project.selector"
import { getCurrentUserId } from "./user.selector"
import { getTaskByEntityId, getEntityId } from "./task.selector"
import { createDeepEqualSelector } from "./util.selector"

export const getSchedule = state => state.projectReducer.selectedSchedule

export const getScheduleId = state => state.projectReducer.selectedScheduleId


export const getScheduleName = createSelector([getSchedule], (schedule) => {
    if(!schedule) return null

    return schedule.name
})

export const getSchedules = createSelector([getProject], (project) => {
    if (!project) return {}

    return project.schedules
})

export const getScheduleList = createDeepEqualSelector([getSchedules], (schedules) => dockPadEntityMapToList(schedules)
)

export const getScheduleTaskIds = createSelector([getSchedule], (schedule) => {
    if (!schedule) return {}

    return schedule.tasks
})

export const getScheduleToEditId = (state, props) => props.scheduleDrawerId

export const getScheduleToEdit = createSelector([getSchedules, getScheduleToEditId], (schedules, scheduleId) => {
    return schedules[scheduleId]
})

export const getUsersScheduleList = createSelector([getScheduleList, getCurrentUserId], (scheduleList, currentUserId) => {
    return scheduleList.filter(item => { return !!item.users && item.users[currentUserId] })
})

export const getCurrentUsersScheduleSelectList = createSelector([getUsersScheduleList], (schedules) => {
    return schedules.map(item => {
        return {
            uid: item.uid,
            name: item.name
        }
    })
})

export const getScheduleWithTasksOrMaster = createSelector([getUsersScheduleList, state => state.editboardReducer], (scheduleList, taskId) => {
    const filteredSchedules = scheduleList.filter(item => {
        const tasks = !!item.tasks ? item.tasks : {}
        return !!tasks[taskId]
    })

    const filteredScheduleOrMaster = filteredSchedules.length > 0 ? filteredSchedules : [{ uid: 'master_schedule_id'}]

    const mappedFilteredScheduleList = filteredScheduleOrMaster.reduce(function (map, obj) {
        map[obj.uid] = true
        return map
    }, {})

    return mappedFilteredScheduleList
})


// WEBPACK FOOTER //
// ./src/selectors/schedule.selector.tsx